import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { UserService } from 'src/app/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SwitchWebhookService } from 'src/app/_services/switch-webhook.service';
import { CustomerService } from 'src/app/_services/customer.service';
import { MessageService } from 'primeng/api';
import { FormBuilder, Validators } from '@angular/forms';
import { confirmPasswordValidator } from 'src/app/validators/confirm-password.validator';
import { ShareFormComponent } from 'src/app/_share/components/share-form/share-form.component';
import { FormFields } from 'src/app/_share/_models/forms/form-fields.interface';
import { ClinicService } from 'src/app/_services/clinic.service';

@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.scss'],
})
export class RegisterUserComponent implements OnInit {
  roles: any[] = [];
  customers: any[] = [];
  selectedCustomer: any;
  submitted: boolean = false;
  loading: boolean = false;
  selectedRole: any;
  webhook: any;
  user: any;
  userRole: any;
  disabled: boolean = false;
  clinics: any[] = [];

  data: any;

  @ViewChild(ShareFormComponent) sfc!: ShareFormComponent;

  userForm = this.fb.group(
    {
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', Validators.required],
      username: ['', Validators.required],
      role_id: ['', Validators.required],
      enabled: [true],
      scope: [''],
      password: [''],
      confirm_password: [''],
      webhook: [''],
      customer: this.fb.group({
        id: [''],
      }),
    },
    { validators: confirmPasswordValidator }
  );

  constructor(
    public userService: UserService,
    private customerService: CustomerService,
    public location: Location,
    public ref: DynamicDialogRef,
    private messageService: MessageService,
    private SwitchWebhookService: SwitchWebhookService,
    private config: DynamicDialogConfig,
    private fb: FormBuilder,
    private clinicService: ClinicService
  ) {}

  ngOnInit(): void {
    this.userForm.reset();

    this.data = this.config.data;
    console.log(this.data);

    if (this.data.formdata == 'head-office-user') {
      this.clinicService.getAllClinicRoles().subscribe((roles: any) => {
        console.log('Clinic Roles: ', roles);

        this.roles = roles.body;
        this.user = this.userService.currentUser$.subscribe((user: any) => {
          this.userRole = user?.role?.name;
          console.log(this.userRole);

          this.user = user;
        });
      });
    } else {
      this.userService.getRoles().subscribe((roles: any) => {
        this.roles = roles;
        this.user = this.userService.currentUser$.subscribe((user: any) => {
          this.userRole = user?.role?.name;
          console.log(this.userRole);

          this.user = user;
          if (this.user.role.name === 'admin-switch') {
            this.disabled = true;
            this.selectedRole = this.roles.find((role) => role.id === 14)?.id;
          }
        });
      });
    }
    this.customerService.getAllCustomers().subscribe((customers) => {
      this.customers = customers;
    });
  }

  get f() {
    return this.userForm.controls;
  }

  onChange(event: any) {}

  onSubmitUserForm() {
    this.loading = true;
    this.submitted = true;

    if (this.userForm.valid) {
      this.userService.postUser(this.userForm.value).subscribe(
        (res) => {
          if (this.userForm.value.webhook) {
            let webhookObject = {
              user_id: res.id,
              base_url: this.userForm.value.webhook,
            };

            this.SwitchWebhookService.createBaseUrl(webhookObject).subscribe(
              (res) => {}
            );
          }

          this.userService.getAll().subscribe(
            (users) => {
              this.userService.updateMembers(users);
            },
            (error: any) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'User Creation Failed',
                key: 'register',
              });
            }
          );
          this.loading = false;
          this.userForm.reset();
          this.ref.close(res);
        },
        (error: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'User Creation Failed',
            key: 'register',
          });
        }
      );
    }
  }
}
